var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIconCheckCircleGreen = function SvgIconIconCheckCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(2.5 2.5)",
    fill: "#6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.062 29.332c.55 0 1.1-.21 1.519-.63l13.75-13.75a2.148 2.148 0 1 0-3.038-3.038L16.062 24.145l-5.356-5.356a2.148 2.148 0 1 0-3.038 3.038l6.875 6.875c.42.42.97.63 1.519.63z",
    fill: "#FFF"
  }))));
};
export default SvgIconIconCheckCircleGreen;